<template>
  <v-settings-sidebar v-model="show" temporary>
    <!-- Classification selector -->
    <v-list-tile class="py-4">
      <v-classification-selector />
    </v-list-tile>
    <!-- Features -->
    <v-features />
  </v-settings-sidebar>
</template>

<script>
import VClassificationSelector from "./ClassificationSelector";
import VFeatures from "./Features";
import VSettingsSidebar from "@/components/sidebars/SettingsSidebar.vue";

export default {
  components: {
    VClassificationSelector,
    VFeatures,
    VSettingsSidebar
  },
  computed: {
    show: {
      get() {
        return this.$store.state.ner.show.sidebar;
      },
      set(value) {
        this.$store.commit("ner/setShowSidebar", value);
      }
    }
  }
};
</script>
